module.exports = __webpack_public_path__ + "img/b6-3.7f060fa.svg";